
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Festify from './Festify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Festify />
  </React.StrictMode>
);
